import { lazy } from 'react'
import { authRoles } from '../../../auth/authRoles'

const EventosGestion = lazy(() => import('./view/EventosGestion'))
const EventosSistemaGestion = lazy(() => import('./view/EventosSistemaGestion'))
export const eventosRoutesMap = {
  gestion: {
    path: '/eventos/gestion',
    name: 'Gestión de Eventos',
  },
  gestionEvs: {
    path: '/eventos/gestion-eventos-sistema',
    name: 'Gestion Eventos Sistema',
  },
}
const eventosRoutes = [
  {
    path: eventosRoutesMap.gestion.path,
    element: <EventosGestion />,
    auth: authRoles.admin,
  },
  {
    path: eventosRoutesMap.gestionEvs.path,
    element: <EventosSistemaGestion />,
    auth: authRoles.admin,
  },
]
export default eventosRoutes
